// React
import React, { useState } from 'react';

// FutureLab
import { isChatApproved } from '../../../utilities/Chat';
import { ModalConfirmation } from '../../popup/modalConfirmation';
import UserDetails from '../../popup/userDetails';
import avatarPlaceholder from '../../../assets/image/avatar_placeholder.png'
import { ChatListDataInterface } from '../../chat/ChatListItemsDesktop';
import { UserDetailsListItem } from '../../../model';
import { LoggedInUserDetails } from '../../../reducers';
import { OptionStoreItem } from '../../chat/DesktopChatRoomHeader';

// UI
import { ArrowLeft, MoreVertical } from 'lucide-react';
import { Avatar, AvatarFallback } from '../../ui/avatar';
import { getUserDisplayName } from '../../../utilities/UserDetails';
import { Button } from '../../ui/button';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from '../../ui/dropdown-menu';


interface PersonalChatTopNavBarProps {
	chatInFocus: ChatListDataInterface;
	loggedInUserDetails: LoggedInUserDetails;
	userProfileDetails: UserDetailsListItem | undefined;
	goToChatPage: Function;
	displayModalConfirmation: boolean;
	setDisplayModalConfirmation: any;
	optionSelectorChatMessages: Function;
	optionStore: OptionStoreItem;
	setOptionStore: any;
	optionsPersonalChat: OptionStoreItem[];
	photoUrl: string;
}

export default function PersonalChatTopNavBar(personalChatTopNavBarProps: PersonalChatTopNavBarProps) {
	const {
		chatInFocus,
		loggedInUserDetails,
		userProfileDetails,
		goToChatPage,
		displayModalConfirmation,
		setDisplayModalConfirmation,
		optionSelectorChatMessages,
		optionStore,
		setOptionStore,
		optionsPersonalChat,
		photoUrl,
	} = personalChatTopNavBarProps;
	const [displayUserDetails, setDisplayUserDetails] = useState<boolean>(false);
	const [menuOpen, setMenuOpen] = useState(false);
	const handleClose = () => setMenuOpen(false);

	const openPopUp = (option: string) => {
		setDisplayModalConfirmation(!displayModalConfirmation);
		handleClose();
	};

	const userProfileDetailsFullName = getUserDisplayName(userProfileDetails);

	const renderPersonalOption = () => {
		return optionsPersonalChat.map((optionPersonalChat) => (
			<DropdownMenuItem
				key={optionPersonalChat.option}
				className="justify-center"
				onClick={() => {
					setOptionStore(optionPersonalChat);
					openPopUp(optionPersonalChat.option);
				}}
			>
					{optionPersonalChat.option}
			</DropdownMenuItem>
		));
	};

	return (
		<div className="flex h-[60px] w-full min-w-0 items-center overflow-x-hidden border-b-2 border-solid bg-white px-1">
			<div className="flex w-11 shrink-0 justify-center p-0 text-center">
				<Button variant="ghost" size="icon" onClick={() => goToChatPage()}>
					<ArrowLeft className="size-5 text-[#575757]" />
					<span className="sr-only">Back to chats</span>
				</Button>
			</div>
			<div className="flex w-14 shrink-0 justify-center text-center">
				{!!userProfileDetails?.profile_photo ? (
					<button
						type="button"
						onClick={() => {
							setDisplayUserDetails(!displayUserDetails);
						}}
					>
						<img
							src={`${photoUrl}/${userProfileDetails?.id}/${userProfileDetails?.profile_photo}`}
							className="chat-list-image-holder"
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
							currentTarget.src = avatarPlaceholder;
						}}
						/>
					</button>
				) : (
					<Avatar
						className="cursor-pointer"
						onClick={() => {
							setDisplayUserDetails(!displayUserDetails);
						}}
					>
						<AvatarFallback>
						{userProfileDetails?.firstname?.charAt(0).toLocaleUpperCase() || '?'}
						{userProfileDetails?.lastname?.charAt(0).toLocaleUpperCase() ?? ''}
						</AvatarFallback>
					</Avatar>
				)}
			</div>
			{displayUserDetails && (
				<UserDetails
					setDisplayUserDetails={setDisplayUserDetails}
					displayUserDetails={displayUserDetails}
					userProfileDetails={userProfileDetails}
					photoUrl={photoUrl}
				/>
			)}
			<div className="min-w-0 flex-1 truncate px-1 capitalize text-base">{userProfileDetailsFullName}</div>
			<div className="flex w-11 shrink-0 justify-center">
				{isChatApproved(chatInFocus, loggedInUserDetails?.id) && (
					<DropdownMenu open={menuOpen} onOpenChange={setMenuOpen}>
						<DropdownMenuTrigger render={<Button variant="ghost" size="icon" />}>
							<MoreVertical className="size-5 text-[#575757]" />
							<span className="sr-only">Chat options</span>
						</DropdownMenuTrigger>
						<DropdownMenuContent align="end" className="w-40 text-center">
							{renderPersonalOption()}
						</DropdownMenuContent>
					</DropdownMenu>
				)}
			</div>
			{displayModalConfirmation && (
				<ModalConfirmation
					displayModalConfirmation={displayModalConfirmation}
					setDisplayModalConfirmation={setDisplayModalConfirmation}
					optionStore={optionStore}
					callBackProceedMethodProp={() => optionSelectorChatMessages(optionStore?.option)}
				/>
			)}
		</div>
	);
}
